Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _Spacing = require('./Spacing');

var _Spacing2 = _interopRequireDefault(_Spacing);

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  hero: _propTypes2['default'].bool,
  spacing: _propTypes2['default'].number,
  spacingBottom: _propTypes2['default'].number,
  spacingTop: _propTypes2['default'].number
}));

var defaultProps = {
  hero: false,
  spacing: 2,
  spacingBottom: _Spacing.defaultProps.bottom,
  spacingTop: _Spacing.defaultProps.top
};

function Rule(_ref) {
  var css = _ref.css,
      spacingBottom = _ref.spacingBottom,
      spacingTop = _ref.spacingTop,
      spacing = _ref.spacing,
      hero = _ref.hero,
      styles = _ref.styles;

  return _react2['default'].createElement(
    _Spacing2['default'],
    {
      bottom: spacingBottom,
      top: spacingTop,
      vertical: spacing
    },
    _react2['default'].createElement('div', css(styles.rule, hero && styles.hero))
  );
}

Rule.componentCategory = 'Core';
Rule.displayName = 'Rule';
Rule.propTypes = propTypes;
Rule.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var unit = _ref2.unit,
      color = _ref2.color;
  return {
    rule: {
      borderBottom: '1px solid ' + String(color.divider)
    },

    hero: {
      width: 6 * unit
    }
  };
}, { pureComponent: true })(Rule);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Rule.js
// module id = 55
// module chunks = 923280921217 68915827593439 79611799117203 226167001850149